// Direct module, not the common/helpers barrel: the barrel pulls in the redux
// store, which makes this untestable in isolation.
import { history } from 'common/helpers/history';

// A site link target is either a path, or a builder called with the site's
// account id. The builder may seed the destination page's filters before
// returning, and returns a path or a { pathname, search } location.
export const resolveSiteTarget = (to, accountId) => {
  const target = typeof to === 'function' ? to(accountId) : to;
  if (!target) return null;
  return typeof target === 'string' ? { pathname: target } : target;
};

// Shared by every org widget row so the flex rows and the scorecard's table
// rows navigate identically.
export const navigateToSite = (selectAccount, accountId, to) => {
  if (!to) {
    selectAccount(accountId);
    return;
  }

  // Switch first, without the default home redirect. selectAccount swallows its
  // own errors and resolves with undefined on failure, so a falsy result is the
  // only signal the switch did not happen — navigating regardless would land on
  // the target page still scoped to the previous site. Resolving the target
  // only on success also keeps a builder from seeding filters for a site we
  // never reached.
  Promise.resolve(selectAccount(accountId, false)).then((user) => {
    if (!user) return;
    const target = resolveSiteTarget(to, accountId);
    if (target) history.push(target);
  });
};
